// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IRoleHttpResponse } from 'app_types/admin/role/roleTypes'
// @end

class RoleService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async getRoles(params: any = {}) {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/secure/role`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  insertOrUpdate = async (roleData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: IRoleHttpResponse
    const formData = new FormData()

    Object.keys(roleData).map((key: string) => {
      if (typeof roleData[key] === 'object' && !!roleData[key][0]?.name && !!roleData[key][0].type) {
        formData.append(key, roleData[key][0])
      } else if (typeof roleData[key] === 'object' && !(roleData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(roleData[key]))
      } else {
        formData.append(key, roleData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/secure/role/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.role
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IRoleHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/secure/role/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.role
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/secure/role/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  async getPermissions () {
    this.refreshAuthToken()

    let responseData: any //IAlliancesHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/secure/app-module/permission`,
      auth_token: this.token,
    }
    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    }
    return null
  }

}

export default RoleService
